import { Button, Form, Select, Space, TimePicker } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
interface AvailableTimePickerProps {
    onGetAvailableTimes?: (availableTimes: any[]) => void;
}
export default function AvailableTimePicker(props: AvailableTimePickerProps) {
    const { onGetAvailableTimes } = props;
    const form = Form.useFormInstance();

    const handleGetAvailableTimes = () => {
        const availableTimes = form.getFieldValue("availableTimes") || [];

        const newAvailableTimes = availableTimes.reduce((acc: any[], item: any) => {
            if (!item?.time || item.time.length !== 2) return acc;

            const [start, end] = item.time;

            if (start.isAfter(end) || start.isSame(end)) {
                toast.error("Thời gian kết thúc phải lớn hơn thời gian bắt đầu");
                return acc;
            }

            acc.push({
                dayOfWeek: item.dayOfWeek,
                startTime: start.format("HH:mm"),
                endTime: end.format("HH:mm"),
            });

            return acc;
        }, []);

        if (onGetAvailableTimes && newAvailableTimes.length > 0) {
            onGetAvailableTimes(newAvailableTimes);
        }
    };

    return (
        <Form.List name="availableTimes">
            {(fields, { add, remove }) => (
                <div className="flex flex-col gap-4">
                    <div className="w-[40px] flex items-center">
                        <Button onClick={() =>
                            add({
                                dayOfWeek: "monday",
                                time: [
                                    dayjs(),
                                    dayjs().add(1, "hour"),
                                ],
                            })
                        }>Thêm thời gian rảnh</Button>
                        <Button onClick={handleGetAvailableTimes} className="ml-[20px]">Lưu</Button>
                    </div>

                    <div className="flex flex-col gap-y-[10px]">
                        {fields.map(({ key, name }) => (
                            <Space key={key} className="flex items-center">
                                <Form.Item
                                    name={[name, "dayOfWeek"]}
                                    className="min-w-[140px] mb-0"
                                >
                                    <Select
                                        options={[
                                            { label: "Thứ hai", value: "monday" },
                                            { label: "Thứ ba", value: "tuesday" },
                                            { label: "Thứ tư", value: "wednesday" },
                                            { label: "Thứ năm", value: "thursday" },
                                            { label: "Thứ sáu", value: "friday" },
                                            { label: "Thứ bảy", value: "saturday" },
                                            { label: "Chủ nhật", value: "sunday" },
                                        ]}
                                        defaultValue={{ label: "Thứ hai", value: "monday" }}
                                    />
                                </Form.Item>

                                <Form.Item name={[name, "time"]} className="mb-0">
                                    <TimePicker.RangePicker format="HH:mm" />
                                </Form.Item>

                                <Button onClick={() => remove(name)}>X</Button>
                            </Space>
                        ))}
                    </div>
                </div>
            )}
        </Form.List>
    );
}
